import { render } from "./Meetings.vue?vue&type=template&id=747213c1&scoped=true"
import script from "./Meetings.vue?vue&type=script&lang=js"
export * from "./Meetings.vue?vue&type=script&lang=js"

import "./Meetings.vue?vue&type=style&index=0&id=747213c1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747213c1"]])

export default __exports__